import React from 'react'
import { ReadingComprehensionCellStyles } from './Style'
import { ratingColors5, ratingColors6 } from 'keys/rating'
import { last } from 'lodash'
import { Chip } from 'components/Form'

const ReadingComprehensionCell = (props) => {
    const { cell, row } = props
    const hasQuestions = cell.getValue()
    const { correct_count, total_count } = row.original.rating || {}

    const incorrectCount = total_count - correct_count + 1

    const color = ratingColors5?.[incorrectCount] || last(ratingColors5)
    const bg = ratingColors6?.[incorrectCount] || last(ratingColors6)

    if ((!total_count && !correct_count) || !hasQuestions)
        return null

    return (
        <ReadingComprehensionCellStyles>
            <div className='mark-chip'>
                <Chip color={color} bg={bg}>
                    {correct_count}/{total_count}
                </Chip>
            </div>
        </ReadingComprehensionCellStyles>
    )
}

export default ReadingComprehensionCell